import { Expose, plainToClass } from 'class-transformer';
import BasketBillingMethod from './BasketBillingMethod';
import type BillingField from '../types/BillingField';

export default class GiftCard {
  @Expose() number: string = '';
  @Expose() pin: string = '';
  @Expose() saveonfile: boolean = false;

  constructor(
    number: string,
    pin: string,
    saveonfile: boolean
  ) {
    this.number = number;
    this.pin = pin;
    this.saveonfile = saveonfile;
  }

  isFn = ((): boolean => {
    return true;
  })

  toBasketBillingMethod = ((schemeId: number): BasketBillingMethod => {
    const bbm = plainToClass(BasketBillingMethod, {
      billingmethod: 'storedvalue',
      billingschemeid: schemeId,
      billingfields: [
        {
          name: "number",
          value: this.number,
        },
        {
          name: "pin",
          value: this.pin,
        } as BillingField
      ],
      saveonfile: this.saveonfile,
    }, { excludeExtraneousValues: true });
    return bbm;
  })
}
